import {serviceAPI, serviceAPIDownloadFile} from "../service"
import {
    PROCESS_LISTING_APPLICATION_URL,
    MARK_APPLICATION_AS_VIEWED_URL,
    CANCEL_TOUR_BOOKING_URL,
    DELETE_LISTING_APPLICATION_URL,
    DELETE_LISTING_DOCUMENT_URL,
    REORDER_LISTING_DOCUMENTS_URL,
    DELETE_LISTING_URL,
    GET_APPLICATIONS_NOTE_URL,
    GET_APPLICATIONS_URL, USER_APPOINTMENT_BY_LISTING_URL,
    GET_APPOINTMENTS_URL,
    GET_FAVORITE_LISTINGS_URL,
    GET_LISTING_IMAGE_URL,
    GET_LISTINGS_BY_PERSON_ID_URL,
    GET_LISTINGS_SECURE_URL,
    GET_LISTINGS_URL,
    GET_TOTAL_LISTINGS_URL,
    GET_TOTAL_LISTINGS_BY_PERSON_ID_URL,
    APPOINTMENTS_BY_LISTING_URL,
    SAVE_APPOINTMENT_URL,
    SAVE_FAVORITE_LISTING_URL,
    SAVE_LISTINGS_APPLICATION_URL,
    SAVE_LISTINGS_URL,
    SOCIAL_REGISTRATION_URL,
    UPLOAD_LISTING_DOCUMENT_URL,
    LIST_MONTH_APPOINTMENTS_URL,
    GET_FEATURED_LISTINGS_URL,
    GET_LISTING_DETAILS_URL,
    GET_ALL_LISTINGS_URL,
    GET_LISTING_DETAILS_SECURE_URL,
    TOGGLE_LISTING_STATUS_URL,
    PROCESS_LISTING_APPOINTMENTS_URL,
    LIST_MONTH_APPOINTMENTS_INDICATORS_URL,
} from "../../constants/url.constants"
import {handleErrorResponse} from "../../actions/message"

export const saveListingData = (data) => {
    return serviceAPI.post(SAVE_LISTINGS_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getListingsUnsecure = (data) => {
    const {propertyType, listingType, name, noOfBeds, noOfBaths, sqftMin, sqftMax, priceMin, priceMax, pageNo, rowsPerPage, bounds} = data
    let url = GET_LISTINGS_URL + "?propertyTypeCd=" + propertyType + "&listingTypeCd=" + listingType + "&propertyName=" + name +
        "&noOfBeds=" + noOfBeds + "&noOfBaths=" + noOfBaths + "&sqftMin=" + sqftMin + "&sqftMax=" + sqftMax + "&priceMin=" + priceMin + "&priceMax=" + priceMax +
        "&pageNo=" + pageNo + "&rowsPerPage=" + rowsPerPage
    return serviceAPI
        .post(url, {bounds: bounds})
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getListingsSecure = (data) => {
    const {propertyType, listingType, name, noOfBeds, noOfBaths, sqftMin, sqftMax, priceMin, priceMax, pageNo, rowsPerPage, bounds} = data
    let url = GET_LISTINGS_SECURE_URL + "?propertyTypeCd=" + propertyType + "&listingTypeCd=" + listingType + "&propertyName=" + name +
        "&noOfBeds=" + noOfBeds + "&noOfBaths=" + noOfBaths + "&sqftMin=" + sqftMin + "&sqftMax=" + sqftMax + "&priceMin=" + priceMin + "&priceMax=" + priceMax +
        "&pageNo=" + pageNo + "&rowsPerPage=" + rowsPerPage
    return serviceAPI
        .post(url, {bounds: bounds})
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getListingsByPersonId = (propertyType, listingType, name, pageNo, rowsPerPage) => {
    let url = GET_LISTINGS_BY_PERSON_ID_URL + "?propertyTypeCd=" + propertyType + "&listingTypeCd=" + listingType + "&propertyName=" + name +
        "&pageNo=" + pageNo + "&rowsPerPage=" + rowsPerPage
    return serviceAPI
        .get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getTotalListings = (propertyType, listingType, name) => {
    let url = GET_TOTAL_LISTINGS_URL + "?propertyTypeCd=" + propertyType + "&listingTypeCd=" + listingType + "&propertyName=" + name
    return serviceAPI
        .get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getTotalListingsByPersonId = (propertyType, listingType, name) => {
    let url = GET_TOTAL_LISTINGS_BY_PERSON_ID_URL + "?propertyTypeCd=" + propertyType + "&listingTypeCd=" + listingType + "&propertyName=" + name
    return serviceAPI
        .get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getListingImage = (filename) => {
    return serviceAPIDownloadFile.get(GET_LISTING_IMAGE_URL + "?filename=" + filename)
}

export const saveListingApplication = (data) => {
    return serviceAPI.post(SAVE_LISTINGS_APPLICATION_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const deleteListingApplication = (applicationId) => {
    return serviceAPI.post(DELETE_LISTING_APPLICATION_URL, { applicationId })
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const listApplications = (listing, status) => {
    let url = GET_APPLICATIONS_URL + "?listingName=" + listing + "&status=" + status
    return serviceAPI
        .get(url)
        .then((response) => {
            // Handle the new response format with subscription validation
            if (response.data.type === "error" && response.data.requiresSubscription) {
                // Return the error response data instead of throwing
                return response.data
            }
            return response.data.applications || response.data
        }).catch(error => {
            // Re-throw the error so it can be handled by the component
            throw error
        })
}

export const listMyApplications = (status) => {
    let url = GET_APPLICATIONS_URL.replace('getApplications', 'getMyApplications') + "?status=" + (status || "")
    return serviceAPI
        .get(url)
        .then((response) => {
            return response.data.applications || response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getListingApplicationNotes = (applicationId, pageNo) => {
    return serviceAPI
        .get(GET_APPLICATIONS_NOTE_URL + "?applicationId=" + applicationId + "&pageNo=" + pageNo)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const saveFavoriteListing = (data) => {
    return serviceAPI.post(SAVE_FAVORITE_LISTING_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getPersonFavoritesList = () => {
    return serviceAPI
        .get(GET_FAVORITE_LISTINGS_URL)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const handleSocialRegistration = (data) => {
    return serviceAPI
        .post(SOCIAL_REGISTRATION_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const uploadListingDocument = (listingId, data) => {
    return serviceAPI
        .post(UPLOAD_LISTING_DOCUMENT_URL + listingId, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const deleteListingDocument = (listingId, data) => {
    return serviceAPI
        .post(DELETE_LISTING_DOCUMENT_URL + listingId, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const reorderListingDocuments = (listingId, documentIds) => {
    return serviceAPI
        .post(REORDER_LISTING_DOCUMENTS_URL + listingId, { documentIds })
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const deleteListing = (listingId) => {
    return serviceAPI
        .post(DELETE_LISTING_URL + listingId)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const saveAppointment = (data) => {
    return serviceAPI.post(SAVE_APPOINTMENT_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const listAppointments = (date) => {
    let url = GET_APPOINTMENTS_URL + date.toISOString();

    return serviceAPI
        .get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getAppointmentForListing = (listingId) => {
    const url = USER_APPOINTMENT_BY_LISTING_URL + listingId
    return serviceAPI
        .get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const listAppointmentsForListing = (listingId) => {
    const url = APPOINTMENTS_BY_LISTING_URL + listingId
    return serviceAPI
        .get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const listMonthAppointments = (year, month) => {
    const url = LIST_MONTH_APPOINTMENTS_URL + `?year=${year}&month=${month}`
    return serviceAPI
        .get(url)
        .then((response) => {
            // For web, show only incoming appointments (asOwner)
            // For mobile, this would show both asVisitor and asOwner
            return response.data || []
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const listMonthAppointmentIndicators = (year, month) => {
    const url = LIST_MONTH_APPOINTMENTS_INDICATORS_URL + `?year=${year}&month=${month}`
    return serviceAPI
        .get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const cancelTourBooking = (bookingId) => {
    const url = CANCEL_TOUR_BOOKING_URL + bookingId
    return serviceAPI
        .post(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getListingById = (listingId) => {
    const url = GET_LISTING_DETAILS_URL + listingId
    return serviceAPI
        .get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getListingByIdSecured = (listingId) => {
    const url = GET_LISTING_DETAILS_SECURE_URL + listingId
    return serviceAPI
        .get(url)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}



export const getFeaturedListings = (data) => {
    return serviceAPI
        .post(GET_FEATURED_LISTINGS_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getAllListings = () => {
    return serviceAPI
        .get(GET_ALL_LISTINGS_URL)
        .then((response) => response.data)
        .catch(error => {
            handleErrorResponse(error)
        })
}

export const processListingApplication = (data) => {
    return serviceAPI.post(PROCESS_LISTING_APPLICATION_URL, data)
        .then((response) => {
            // Handle the new response format with subscription validation
            if (response.data.type === "error" && response.data.requiresSubscription) {
                throw new Error(response.data.message)
            }
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const markApplicationAsViewed = (data) => {
    return serviceAPI.post(MARK_APPLICATION_AS_VIEWED_URL, data)
        .then((response) => {
            // Handle the new response format with subscription validation
            if (response.data.type === "error" && response.data.requiresSubscription) {
                throw new Error(response.data.message)
            }
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getPendingApplicationsCount = () => {
    return serviceAPI
        .get(GET_APPLICATIONS_URL + "?listingName=&status=PEN")
        .then((response) => {
            // Handle both success and error responses that include applications
            if (response.data.type === "success" && response.data.applications) {
                return response.data.applications.length
            }
            
            // Handle error response with applications (for blurred display)
            if (response.data.type === "error" && response.data.requiresSubscription && response.data.applications) {
                return response.data.applications.length
            }
            
            // Handle legacy response format
            if (Array.isArray(response.data)) {
                return response.data.length
            }
            
            return 0
        })
        .catch((error) => {
            console.error("getPendingApplicationsCount error", error);
            return 0
        })
}

export const toggleListingStatus = (listingId) => {
    return serviceAPI
        .post(TOGGLE_LISTING_STATUS_URL + listingId)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const processListingAppointment = (data) => {
    return serviceAPI.post(PROCESS_LISTING_APPOINTMENTS_URL, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}